function throwError(error) {
  return function (start, sink) {
    if (start !== 0) return;
    var disposed = false;
    sink(0, function (end) {
      if (end !== 2) return;
      disposed = true;
    });
    if (disposed) return;
    sink(2, error || new Error());
  };
}

export default throwError;
